import { Box, Button, CheckBox, Form, FormField, TextInput } from "grommet";
import { Save } from "grommet-icons";
import React, { useEffect, useState } from "react";
import { useFolderQuery, useUpdateFolderMutation } from "../generated/graphql";

interface Props {
  showModal: boolean;
  setShowModal(s: boolean): void;
  folderId: string;
}

export const EditFolder: React.FC<Props> = ({ setShowModal, folderId }) => {
  const [privilegedChecked, setPrivilegedChecked] = useState(false);
  const [name, setName] = useState("");

  const { data } = useFolderQuery({
    variables: {
      id: folderId
    }
  });

  useEffect(() => {
    if (data && data.folder) {
      setName(data.folder.name);
      setPrivilegedChecked(data.folder.isPrivileged!);
    }
  }, [data, folderId]);

  const [updateFolder] = useUpdateFolderMutation({
    refetchQueries: [`Company`]
  });
  // const [createArticle] = useCreateArticleMutation({
  //   refetchQueries: ["articles"]
  // });

  if (!data) {
    return null;
  }

  return (
    <Box pad="large">
      <h2>Redigera mapp</h2>
      <Form>
        <FormField label="Namn">
          <TextInput
            value={name}
            placeholder="skriv här"
            onChange={({ target }) => {
              setName(target.value);
            }}
          />
        </FormField>
        <CheckBox
          checked={privilegedChecked}
          label="Visa endast för priviligerade användare"
          onChange={() => setPrivilegedChecked(!privilegedChecked)}
        />
        <hr />
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <Button
            primary
            icon={<Save />}
            label="Spara"
            onClick={async () => {
              try {
                updateFolder({
                  variables: {
                    id: folderId,
                    name,
                    isPrivileged: privilegedChecked
                  }
                });
                // createArticle({
                //   variables: {
                //     title: title,
                //     content: htmlContent,
                //     sms: smsChecked,
                //     mail: mailChecked,
                //     isPrivileged: privilegedChecked
                //   }
                // });
                setShowModal(false);
              } catch (error) {
                console.log(error);
              }
            }}
          />
          <Button label="Stäng" onClick={() => setShowModal(false)} />
        </div>
      </Form>
    </Box>
  );
};
